import { prop, propOr } from 'ramda';
import { createSelector } from 'reselect';

import { EMPTY_VALUES } from 'constants/general';

import { NAME } from './constants';

const getRoot = prop(NAME);

export const getSemaphoreData = createSelector(getRoot, propOr(EMPTY_VALUES.OBJECT, 'data'));
